import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceipt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.69336 3.63086V3.89355H4.38477V3.63086H4.69336Z",
			stroke: "#6B9C67"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_4125_14068",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M7.32227 8.82341V3.13086H8.14199V8.82341H7.32227Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.32227 8.82341H6.32227V9.82341H7.32227V8.82341ZM7.32227 3.13086V2.13086H6.32227V3.13086H7.32227ZM8.14199 3.13086H9.14199V2.13086H8.14199V3.13086ZM8.14199 8.82341V9.82341H9.14199V8.82341H8.14199ZM7.32227 8.82341H8.32227V3.13086H7.32227H6.32227V8.82341H7.32227ZM7.32227 3.13086V4.13086H8.14199V3.13086V2.13086H7.32227V3.13086ZM8.14199 3.13086H7.14199V8.82341H8.14199H9.14199V3.13086H8.14199ZM8.14199 8.82341V7.82341H7.32227V8.82341V9.82341H8.14199V8.82341Z",
			fill: "#6B9C67",
			mask: "url(#path-2-inside-1_4125_14068)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-4-inside-2_4125_14068",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M8.92969 8.82341V3.13086H9.74941V8.01507H11.3661V8.8348H8.92969V8.82341Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.92969 3.13086V2.13086H7.92969V3.13086H8.92969ZM9.74941 3.13086H10.7494V2.13086H9.74941V3.13086ZM9.74941 8.01507H8.74941V9.01507H9.74941V8.01507ZM11.3661 8.01507H12.3661V7.01507H11.3661V8.01507ZM11.3661 8.8348V9.8348H12.3661V8.8348H11.3661ZM8.92969 8.8348H7.92969V9.8348H8.92969V8.8348ZM8.92969 8.82341H9.92969V3.13086H8.92969H7.92969V8.82341H8.92969ZM8.92969 3.13086V4.13086H9.74941V3.13086V2.13086H8.92969V3.13086ZM9.74941 3.13086H8.74941V8.01507H9.74941H10.7494V3.13086H9.74941ZM9.74941 8.01507V9.01507H11.3661V8.01507V7.01507H9.74941V8.01507ZM11.3661 8.01507H10.3661V8.8348H11.3661H12.3661V8.01507H11.3661ZM11.3661 8.8348V7.8348H8.92969V8.8348V9.8348H11.3661V8.8348ZM8.92969 8.8348H9.92969V8.82341H8.92969H7.92969V8.8348H8.92969Z",
			fill: "#6B9C67",
			mask: "url(#path-4-inside-2_4125_14068)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-6-inside-3_4125_14068",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M11.8887 8.82341V3.13086H12.7084V8.01507H14.3251V8.8348H11.8887V8.82341Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8887 3.13086V2.13086H10.8887V3.13086H11.8887ZM12.7084 3.13086H13.7084V2.13086H12.7084V3.13086ZM12.7084 8.01507H11.7084V9.01507H12.7084V8.01507ZM14.3251 8.01507H15.3251V7.01507H14.3251V8.01507ZM14.3251 8.8348V9.8348H15.3251V8.8348H14.3251ZM11.8887 8.8348H10.8887V9.8348H11.8887V8.8348ZM11.8887 8.82341H12.8887V3.13086H11.8887H10.8887V8.82341H11.8887ZM11.8887 3.13086V4.13086H12.7084V3.13086V2.13086H11.8887V3.13086ZM12.7084 3.13086H11.7084V8.01507H12.7084H13.7084V3.13086H12.7084ZM12.7084 8.01507V9.01507H14.3251V8.01507V7.01507H12.7084V8.01507ZM14.3251 8.01507H13.3251V8.8348H14.3251H15.3251V8.01507H14.3251ZM14.3251 8.8348V7.8348H11.8887V8.8348V9.8348H14.3251V8.8348ZM11.8887 8.8348H12.8887V8.82341H11.8887H10.8887V8.8348H11.8887Z",
			fill: "#6B9C67",
			mask: "url(#path-6-inside-3_4125_14068)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.16797 14.6667V2.36795C2.16797 1.33479 3.00179 0.5 4.03374 0.5L17.5846 0.5",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.834 5.1582V15.4665",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7507 0.568359C18.809 0.568359 19.659 1.42669 19.659 2.47669V8.01836H15.834V2.47669C15.834 1.41836 16.6923 0.568359 17.7423 0.568359H17.7507Z",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8333 15.4663V17.8163C15.8333 18.8746 14.975 19.7246 13.925 19.7246C12.8667 19.7246 12.0167 18.8663 12.0167 17.8163V14.8496H0.5V17.8163C0.5 18.8746 1.35833 19.7246 2.40833 19.7246H13.9167",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 12.168H10.9167",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.584 12.168L14.2507 12.168",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 10.5H10.9167",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.584 10.5L14.2507 10.5",
			stroke: "#6B9C67",
			strokeMiterlimit: 10
		})
	]
});
export default SvgReceipt;
